// extracted by mini-css-extract-plugin
export default {"status-box":"RecruitmentStatus_status-box__F9U-d","status-box-warning":"RecruitmentStatus_status-box-warning__QfhF5","status-box-error":"RecruitmentStatus_status-box-error__fLE67"};